/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { IconChecked } from '../../svg/IconChecked'
import { IconNoChecked } from '../../svg/IconNoChecked'
import { PurchasePopup } from '../../components/ui/galleryUi/PurchasePopup'
import { ItemCardStatus } from '../../components/ui/galleryUi/itemLabels'
import { TGalleryItemInfo } from '../../store/gallery/types'
import { Watch } from '../../svg/Watch'
import { useAddItemPopup } from '../../hooks/useAddItemPopup'
import { IconLike } from '../../svg/IconLike'
import { addNewParams } from '../../utils/helpers'
import { getUniqueId } from '../../utils/FileUtils'
import { addToFavoritesAction, addToRecommendedAction } from '../../utils/galleryUtils/itemsActions'
import { GetItemInfo } from '../../store/gallery/actions'
import { API_ROUTES } from '../../utils/apiRoutes'
import { recMode } from '../../utils/consts'
import { IconStar } from '../../svg/IconStar'
import { AppStore } from '../../store/applicationState'

interface WatchesCardProps {
  isCatalog: boolean
  tenderId: number
  item: TGalleryItemInfo
}

const ImageAltWrapperS = styled.div`
  width: 100%;
  object-fit: cover;
  aspect-ratio: 1/1;
`

export const WatchesCard: React.FC<WatchesCardProps> = ({ item, tenderId, isCatalog }) => {
  const dispatch = useDispatch()
  const { userData, gallery } = useSelector((store: AppStore) => store)

  const [purchasePopupActive, setPurchasePopupActive] = useState(false)
  const [imgError, setImgError] = useState(false)

  const [prewImg, setprewImg] = useState(item.product_gallery.images[0])

  const itemStatus = item.bid_status_id === 0 && !item.is_sold ? 'open' : ''

  const { add } = useAddItemPopup()

  const openItemPopup = () => {
    dispatch(
      GetItemInfo.request({
        itemId: item.item_id,
        callBack: (success, data) => {
          if (success) {
            const finalized = false
            add({ item: data, isCatalog, finalized, isFromGallery: true })
            addNewParams('item', `${item.item_id}`)
          }
        },
      })
    )
  }

  return (
    <div className={`px-1 ${item.product_gallery.images.length ? '' : 'mobile:w-auto w-full'}`}>
      <div className='item-card p-3 border border-bluegray-100 bg-white lg:w-64 mobile:w-60 w-12/12 mobile:mx-0 mx-5 mb-8 shadow-sm space-y-4'>
        <div className='item-image relative'>
          <div className='image-holder relative flex'>
            <Link
              to={`${API_ROUTES.tenders}/${tenderId}?item=${item.item_id}`}
              onClick={(e) => {
                if (e.nativeEvent.which === 1) {
                  e.preventDefault()
                  openItemPopup()
                }
              }}
              className='w-full'
            >
              {item.product_gallery.images.length && !imgError && item.item_id !== 2859 ? (
                <img
                  src={prewImg}
                  alt='Watches'
                  aria-hidden='true'
                  onError={() => setImgError(true)}
                  className={`border border-bluegray-200 ${itemStatus === 'open' ? '' : 'opacity-25'}`}
                />
              ) : (
                <ImageAltWrapperS className='text-bluegray-400 flex items-center justify-center w-full text-7xl border border-bluegray-200'>
                  <Watch />
                </ImageAltWrapperS>
              )}
            </Link>
            {recMode && (
              <div className='absolute left-1 right-1 top-1 bg-gray-300 opacity-70 p-1'>
                Owner: {item.product.shipping_owner}
                <br />
                Bid/s: {item.product.count_of_bids || 0}
              </div>
            )}
          </div>
        </div>

        <div className='images-slider grid-cols-4 grid gap-3 mobile:h-12'>
          {item.product_gallery.images.length > 1 &&
            item.product_gallery.images.map((image, i) => {
              if (i <= 3) {
                return (
                  <button
                    className='col border border-bluegray-200 hover:border-lightblue-600'
                    type='button'
                    key={getUniqueId()}
                    onClick={() => setprewImg(image)}
                  >
                    <img src={image} alt='Watches' className={` ${itemStatus === 'open' ? '' : 'opacity-25'}`} />
                  </button>
                )
              }
              return ''
            })}
        </div>
        <div className='item-info flex flex-col justify-between mt-4'>
          <div className='flex justify-between flex-col space-y-3 flex-grow'>
            <div className={`item-text text-bluegray-800 ${itemStatus === 'open' ? '' : 'opacity-25'}`}>
              <div className='font-circa text-base text-black mb-2 overflow-hidden md:text-ellipsis h-12'>
                <Link
                  to={`${API_ROUTES.tenders}/${tenderId}?item=${item.item_id}`}
                  onClick={(e) => {
                    if (e.nativeEvent.which === 1) {
                      e.preventDefault()
                      openItemPopup()
                    }
                  }}
                  className='title text-left line-clamp-2'
                >
                  {item.product.title}
                </Link>
              </div>
              <div className='price text-base flex flex-row mobile:flex-col items-center mobile:items-start gap-1 justify-between text-bluegray-500 mb-5  leading-none'>
                <div className='case-material'>{item.product.product_details.case_material}</div>
                <div className='flex'>
                  <div className='text-bluegray-400 mr-1'>
                    {item.product.product_details.year && item.product.product_details.year.includes('Circa')
                      ? 'Year:'
                      : 'Date on Warranty:'}
                  </div>
                  <div className='year'>{item.product.product_details.year}</div>
                </div>
              </div>
              <div className='text-bluegray-800 space-y-3 mb-2 leading-none'>
                <div className='flex justify-between items-center'>
                  <div className='font-semibold mr-1'>Ref #</div>
                  <div className=' border-dotted border-b border-bluegray-300 mx-1 flex-grow' />
                  <div className='ref-number'>{item.product.product_details.ref}</div>
                </div>
                <div className='flex justify-between items-center'>
                  <div className='font-semibold mr-1'>Cond.</div>
                  <div className=' border-dotted border-b border-bluegray-300 mx-1 flex-grow' />
                  <div className='condition'>{item.product.product_details.condition}</div>
                </div>
                <div className='flex justify-between items-center min-h-[15px]'>
                  {item.product.product_details.warranty_type ? (
                    <>
                      <div className='font-semibold mr-1 whitespace-nowrap'>Warranty Type</div>
                      <div className=' border-dotted border-b border-bluegray-300 mx-1 flex-grow' />
                      <div className='papers_type text-ellipsis overflow-hidden whitespace-nowrap pb-[1px]'>
                        {item.product.product_details.warranty_type}
                      </div>
                    </>
                  ) : null}
                </div>
                <div className='flex space-x-3 items-center mt-2 justify-between'>
                  <div className='flex space-x-4'>
                    <div className='box font-semibold'>
                      {item.product.product_details.box === 'Yes' ? (
                        <span className='icon-checked text-green-300 mr-1 text-xxs'>
                          <IconChecked />
                        </span>
                      ) : (
                        <span className='icon-unchecked text-red-400 mr-1 text-xxs'>
                          <IconNoChecked />
                        </span>
                      )}
                      Box
                    </div>
                    <div className='font-semibold papers'>
                      {item.product.product_details.warranty_type ? (
                        <span className='icon-checked text-green-300 mr-1 text-xxs'>
                          <IconChecked />
                        </span>
                      ) : (
                        <span className='icon-unchecked text-red-400 mr-1 text-xxs'>
                          <IconNoChecked />
                        </span>
                      )}
                      Papers
                    </div>
                  </div>
                  <div className='flex flex-row gap-2'>
                    {((gallery.data.atLeastOneRecommended && item.in_recommendations) || recMode) && (
                      <button
                        type='button'
                        disabled={!recMode}
                        onClick={() => {
                          addToRecommendedAction(item.in_recommendations, userData.companyId!, item.item_id, dispatch)
                        }}
                        className='recommendations text-yellow-500 text-lg disabled:opacity-100'
                      >
                        <IconStar isActive={item.in_recommendations} />
                      </button>
                    )}
                    <button
                      type='button'
                      onClick={() => addToFavoritesAction(item.in_favorites, tenderId, item.item_id, dispatch)}
                      className='favorites text-red-500 text-lg'
                    >
                      <IconLike isActive={item.in_favorites} />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {!isCatalog && (
              <ItemCardStatus
                item={item}
                tenderId={tenderId}
                setPurchasePopupActive={setPurchasePopupActive}
                openItemPopup={() => openItemPopup()}
              />
            )}
          </div>
        </div>
      </div>
      {purchasePopupActive && (
        <PurchasePopup
          setPurchasePopupActive={setPurchasePopupActive}
          purchasePopupActive={purchasePopupActive}
          item={item}
          tenderId={tenderId}
        />
      )}
    </div>
  )
}
